import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './hubadmin/layout/layout.component';
import { SigninComponent } from './common/signin/signin.component';
import { AuthGuardService } from './services/auth/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    component: SigninComponent,
  },
  {
    path: 'hubAdmin',
    loadChildren: () => import('./hubadmin/hubadmin.module').then(m => m.HubadminModule)
  },
  {
    path: 'agent',
    loadChildren: () => import('./agent/agent.module').then(m => m.AgentModule)
  },
  {
    path: 'reporting-dashboard',
    loadChildren: () => import('./reporting-dashboard/reporting-dashboard.module').then(m => m.ReportingDashboardModule)
  },
  {
    path: 'branch-manager',
    loadChildren: () => import('./branch-manager/branch-manager.module').then(m => m.BranchManagerModule)
  },
  {
    path: 'invoices',
    loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule)
  },
  {
    path: 'redemption',
    // canActivate: [AuthGuardService],
    loadChildren: () => import('./redemption/redemption.module').then(m => m.RedemptionModule)
  },
  {
    path: 'operationalhead',
    // canActivate: [AuthGuardService],
    loadChildren: () => import('./operationalhead/operationalhead.module').then(m =>m.OperationalheadModule)
  },
    {
    path: 'concierge',
    // canActivate: [AuthGuardService],
    loadChildren: () => import('./concierge/concierge.module').then(m =>m.ConciergeModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true
  })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
